<template>
  <div style="background: #fff;">
    <!-- 头部 -->
    <el-row>
      <el-col :span="4">
        <el-button type="primary" class="width_btn" @click="back">返回</el-button>
      </el-col>
      <el-col :span="16" style="text-align:center">
        <span class="title">调房调级查看</span>
      </el-col>
    </el-row>

    <!--startprint-->
    <el-row ref="print">
      <el-col class="border_gray border_padding">
        <div class="left_title">
          <div class="react"></div>
          <span>老人基本信息</span>
        </div>
        <div class="oldname top30">
          <span class="midtext">老人姓名</span>
          <span class="border">{{tftjInfo.oldmanName}}</span>
        </div>
        <div class="oldname">
          <span class="midtext">身份证号</span>
          <span class="border">{{tftjInfo.idCard}}</span>
        </div>
      </el-col>

      <el-col class="border_gray">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整前</span>
        </div>
        <table border="0px" width="100%" class="six">
          <tr>
            <td>类别</td>
            <td>项目</td>
            <td>实际费用</td>
            <td>收费类型</td>
            <td>实缴合计</td>
          </tr>
          <tr v-for="(item,index) in beforeItemList" :key="index">
            <td>{{ item.itemType }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.itemFee }}</td>
            <td>{{item.typeStr }}</td>
            <td>{{ item.actualFee }}</td>
          </tr>
        </table>
      </el-col>

      <el-col class="border_gray">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整为</span>
        </div>

        <table border="0px" width="100%" class="six">
          <tr>
            <td>类别</td>
            <td>项目</td>
            <td>实际费用</td>
            <td>收费类型</td>
            <td>实缴合计</td>
          </tr>
          <tr v-for="(item,index) in afterItemList" :key="index">
            <td>{{ item.itemType }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.itemFee }}</td>      
            <td>{{ item.typeStr }}</td>
            <td>{{ item.actualFee }}</td>
          </tr>
        </table>
      </el-col>

      <el-col class="border_gray border_padding">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>调整原因</span>
        </div>
        <el-row>
          <el-col :span="12" class="labelpadding">
            <span class="width120">调整原因</span>
            <el-input readonly class="width200" v-model="tftjInfo.reason"></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">调整日期</span>
            <el-input readonly class="width200" v-model="tftjInfo.date"></el-input>
          </el-col>
        </el-row>
      </el-col>

      <el-col class="border_gray border_padding">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>费用补缴</span>
        </div>
        <el-row>
          <el-col :span="12" class="labelpadding">
            <span class="width120">补缴天数</span>
            <el-input readonly class="width200" v-model="tftjInfo.payDays"></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding">
            <span class="width120">补缴金额</span>
            <el-input readonly class="width200" v-model="tftjInfo.total"></el-input>
          </el-col>
        </el-row>
      </el-col>

      <el-col class="border_gray border_padding" style="margin: 30px 0px">
        <div class="left_title margin_border">
          <div class="react"></div>
          <span>审批状态和原因</span>
        </div>
        <el-row>
          <el-col :span="12" class="labelpadding">
            <span class="width120">审批状态</span>
            <el-input readonly class="width200" v-model="tftjInfo.state"></el-input>
          </el-col>
          <el-col :span="12" class="labelpadding" v-show="reasonShow">
            <span class="width120">原因</span>
            <el-input readonly class="width200" v-model="tftjInfo.remark"></el-input>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!--endprint-->
    <el-col style="background: #fff;display:flex;justify-content:center">
      <el-button type="warning" @click="printInfo">打印</el-button>
    </el-col>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
export default {
  name: "changeFeeShow",
  data() {
    return {
      tftjInfo: {},
      beforeItemList: [],
      afterItemList: [],
      pageData: {},
      type: 1,
      id: 0,
      reasonShow: false,
      fromPath:"",
    };
  },
  methods: {
    printInfo() {
      //打印
      this.$print(this.$refs.print);
    },
    back() {
      bus.$emit("close_current_tags");
    },

    getReason() {
      this.$post("omc/revise/queryCommentById/" + this.id).then(res => {
        console.log(res);
        var message = res[res.length - 1].message;
        this.tftjInfo.remark = message;
      });
    },
    state(res) {
      if (res == 1) {
        return "未提交";
      } else if (res == 2) {
        return "申请中";
      } else if (res == 3) {
        return "部长审核通过";
      } else if (res == 4) {
        this.reasonShow = true;
        this.getReason();
        return "审核未通过";
      } else if (res == 5) {
        return "接待室确认";
      } else if (res == 6) {
        return "收费室确认";
      }
    },
    reason(res) {
      if (res == 1) {
        return "身体条件变差";
      } else if (res == 2) {
        return "老人不适应";
      } else {
        return "主动调整";
      }
    },
    //获取调房调级数据
    getTftjData(id) {
      this.id = id;
      //omc/revise/queryById
      this.$post("omc/revise/queryById/" + id).then(res => {
        this.tftjInfo = res;
        this.controlTftjTcData();
        this.tftjInfo.state = this.state(this.tftjInfo.state);
        //reasonShow
        this.tftjInfo.reason = this.reason(this.tftjInfo.reason);
        if (
          res.reviseSetMealVoList != null &&
          res.reviseSetMealVoList.length > 0
        ) {
          // this.getPageData(res.reviseSetMealVoList);
          this.pageData = res.reviseSetMealVoList;
        }
      });
    },

    getPageData() {
      var pageList = [];
      // for(var i=0;i<list.length;i++){
      //   pageList.push({
      //     setMealName:
      //   })
      // }
    },

    //处理调房调级的数据
    controlTftjTcData() {
      var itemList = this.tftjInfo.reviseItemVoList;
      this.beforeItemList = [];
      this.afterItemList = [];
      for (var i = 0; i < itemList.length; i++) {
        itemList[i].typeStr = itemList[i].costType == 3 ?"按月扣费":"按天扣费"
        if (itemList[i].adjustOrder == 1) {
          if (itemList[i].itemType == '床位费') {
            if(this.tftjInfo.reviseBedVoList!=null && this.tftjInfo.reviseBedVoList[0]!=null){
              itemList[i].itemName =
              this.tftjInfo.reviseBedVoList[0].location;
            }
          }
          this.beforeItemList.push(itemList[i]);
        } else {
          if (itemList[i].itemType == '床位费') {
            if(this.tftjInfo.reviseBedVoList!=null && this.tftjInfo.reviseBedVoList[1]!=null){
              itemList[i].itemName =
              this.tftjInfo.reviseBedVoList[1].location;
            }
          }
          this.afterItemList.push(itemList[i]);
        }
      }
    }
  },
  mounted() {
    var tftjId = sessionStorage.getItem("tftjId");
    if (tftjId != null && tftjId != 0 && tftjId != undefined) {
      this.getTftjData(tftjId);
    }
    bus.$on("tftjId", id => {
      var theid = id.substr(0, id.length - 2);
      this.type = id.substr(id.length - 1, id.length);
      console.log(theid);
      sessionStorage.setItem("tftjId", theid);
      this.getTftjData(theid);
    });
    this.fromPath=sessionStorage.getItem("changeFeeShowFromPath");
  },
  destroyed() {
    bus.$off("tftjId", this.handle);
  }
};
</script>
<style lang="scss" scoped>
.header_padding {
  margin-bottom: 5px;
}
.radio {
  margin: 5px;
}
.width_btn {
  height: 28px;
  text-align: center;
  padding: 5px 30px;
}
.title {
  text-align: center;
  color: #0064ea;
  font-size: 20px;
}
.room_dialog ::v-deep .el-dialog__header {
  padding: 8px 20px 8px;
}
.border_gray {
  border: 1px solid #dddddd;
  border-radius: 5px;
  margin-top: 20px;
  padding-left: 1px;
  padding-right: 1px;
  box-shadow: 2px 2px 4px #ccc;
}
.border_padding {
  padding: 10px 5px;
}
.margin_border {
  margin: 10px 5px;
}

.left_title {
  display: flex;
  align-items: center;
  .react {
    width: 4px;
    height: 26px;
    background: #3a77e2;
    margin-left: 10px;
    margin-right: 8px;
  }
  span {
    font-size: 18px;
  }
}
.item_border {
  border: 1px solid #ddd;
  width: 200px;
  height: 20px;
  padding: 6px 10px;
  display: inline-block;
  margin-left: 60px;
}
.oldname {
  margin-left: 50px;
  margin-top: 10px;
  .star {
    color: red;
  }
  .text {
    margin-left: 13px;
    font-size: 16px;
  }
  .midtext {
    margin-left: 24px;
    font-size: 13px;
  }
  .border {
    border: 1px solid #ddd;
    width: 200px;
    padding: 6px 10px;
    display: inline-block;
    margin-left: 60px;
  }
}
.labelpadding {
  padding-left: 50px;
  margin-top: 10px;
}
.width120 {
  width: 120px;
  display: inline-block;
}
.width200 {
  width: 200px;
}
.top30 {
  margin-top: 30px;
}
table {
  text-align: center;
  line-height: 36px;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  border-color: #fff;
  td {
    border: 1px solid #ddd;
    width: 16.66%;
  }
}
</style>